import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th'; // โหลด locale ภาษาไทย
import 'dayjs/locale/en'; // โหลด locale ภาษาอังกฤษ

dayjs.extend(buddhistEra);

export function formatLocalizedDate(
  date: string | Date | dayjs.Dayjs | number | undefined | null,
  format: string,
): string {
  const currentLocale = dayjs.locale(); // ตรวจสอบ locale ปัจจุบัน

  const formattedDate = dayjs(date);

  if (currentLocale === 'th') {
    // ถ้า locale เป็น 'th' ใช้ .format ด้วย 'BBBB' สำหรับปีพุทธศักราช
    // แทน 'YYYY' ด้วย 'BBBB' เพื่อให้รองรับพ.ศ.
    const buddhistFormat = format.replace(/Y{2,4}/g, (match) => {
      // แปลง 'YY' -> 'BB' และ 'YYYY' -> 'BBBB'
      return match.replace(/Y/g, 'B');
    });

    return formattedDate.locale('th').format(buddhistFormat);
  }

  // ถ้า locale ไม่ใช่ 'th' ก็ใช้ format ปกติ
  return formattedDate.format(format);
}
